import axios from "axios";
import { BASE_URL } from "../../../utils/apiConfig";

const PublicAPI = axios.create({
  baseURL: BASE_URL,
  headers: { "Content-Type": "application/json", Accept: "application/json" },
});

export const acceptInvitation = async (token, org) => {
  const res = await PublicAPI.post(`invitations/${token}/accept`, null, { params: org ? { org } : {} });
  return res.data;
};
export const registerProfile = async (token, payload, org) => {
  const res = await PublicAPI.post(`invitations/${token}`, payload, { params: org ? { org } : {} });
  return res.data;
};
export const getInvitationDetails = async (token, org) => {
  const res = await PublicAPI.get(`invitations/${token}`, { params: org ? { org } : {} });
  return res.data;
};